define("shared/utils/reassign-mavely-profile", ["exports", "later/utils/constants", "later/utils/fetch"], function (_exports, _constants, _fetch) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _exports.reassignMavelyProfile = reassignMavelyProfile;
  0; //eaimeta@70e063a35619d71f0,"later/utils/constants",0,"later/utils/fetch"eaimeta@70e063a35619d71f
  /**
   * PATCH the Mavely reassign endpoint. Just the HTTP call — callers layer their
   * own side effects (state refresh, error logging, 422 target-taken handling).
   *
   * Shared by the linkinbio picker (mavelyBlockManager.reassign) and the OAuth
   * popup's move-confirmation flow (auth ProfileRefreshPopupController), which
   * live in sibling engines and can't cross-import from each other.
   *
   * @param connectionId - MavelyConnection id whose owning SI should change.
   * @param targetSocialIdentityId - SI id to move the connection onto.
   */
  async function reassignMavelyProfile(connectionId, targetSocialIdentityId) {
    await (0, _fetch.fetch)(`/api/v2/mavely_profiles/${connectionId}/reassign`, {
      method: _constants.HttpMethod.Patch,
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        target_social_identity_id: targetSocialIdentityId
      })
    });
  }
  var _default = _exports.default = reassignMavelyProfile;
});